import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { map } from 'rxjs';
import { UsersService } from './users.service';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';
import { StoreService } from './store.service';
import { ProjectsService } from './projects.service';
import { prototype } from 'events';

@Injectable({
  providedIn: 'root'
})
export class CutoffService {

  constructor(
    private main: MainService,
    private usrService : UsersService,
    private storesService : StoreService,
    private projectService : ProjectsService

  ) { }
  private areaNameProjects : string = '/projects'
  private areaNameStores : string = '/stores'

  current_project_camp_id = 0;

  project_cutoff_file_data : any = [];

  checkIfSameProjectThenReplace(id_proy_camp : number){
    return new Promise(async (resolve, reject) => {
      if(this.current_project_camp_id != id_proy_camp ){
       // this.loadCampaignAndFile(id_proy_camp).then((x:any)=>{
       //   resolve(true);
       // });
           this.current_project_camp_id = id_proy_camp; 
            resolve(true);
      }else{
        resolve(true);
      }
    });
  }


  getCutOffDataByFileID(data : any){
    return this.main.postRequest(data, this.areaNameStores + "/cutoffs/getFileID");
  }

  private getCutOffData(id_cutoff: number){
    return this.main.getRequest(this.areaNameStores + "/cuttoff/" + id_cutoff);
  }

  private loadCampaignAndFile(id_proy_camp : number, filtros : any = {}) {
    return new Promise(async (resolve, reject) => {
      this.main.ShowLoading();
      this.projectService.getProjects(id_proy_camp).subscribe((x: any) => {
        this.main.HideLoading();
        let selectedSucursalCorteId = x.data.project.selected_cutoff_id;
      
        if(selectedSucursalCorteId){
        
          this.getCutOffData(selectedSucursalCorteId).subscribe((y: any) =>{
            if(y.data[0].file) {
              let fileX = y.data[0].file;
              if(fileX){
                  this.main.ShowLoading();
                  this.storesService.getCuttOffData(fileX).subscribe(
                    (result : any) => {    
                      this.main.HideLoading();
                      this.project_cutoff_file_data = result.data;
                      this.current_project_camp_id = id_proy_camp; 
                      resolve(true);
                      console.log(result.data, this.current_project_camp_id);
                    },
                    (err : any) => {
                      resolve(false);
                      this.main.HideLoading();
                      console.log(err);
                    }
                  );
              }
            }
            else if(y.data[0].file_id) {
              let data_get = {
                file_id : y.data[0].file_id,
                id_zonas: filtros.id_zonas,
                id_atributos: filtros.id_atributos,
                id_sucursales: filtros.id_sucursales,
                atributos_nombre: filtros.atributos_nombre
              }
              if(data_get){
                this.main.ShowLoading();
                this.storesService.getCuttOffDataByFileID(data_get).subscribe(
                  (result : any) => {    
                    this.main.HideLoading();
                    this.project_cutoff_file_data = result.data;
                    this.current_project_camp_id = id_proy_camp; 
                    resolve(true);
                    console.log(result.data, this.current_project_camp_id);
                  },
                  (err : any) => {
                    resolve(false);
                    this.main.HideLoading();
                    console.log(err);
                  }
                );
            }
          }
          else{
            resolve(false);
          
            }
          });
        }
      },
      (err:any) => {
        resolve(false);
        console.log(err);
            this.main.HideLoading();
      });
    });
  }




  //persistent hace que el cutoff se guarde en el global del servicio
  
       // filtros:
       // id_zonas,
       // id_atributos,
       // id_sucursales,
       // atributos_nombre
     
   getCutOffFile(id_proy_camp : number, filtros : any = {}, sucursales_filtro : any = [], persistent : boolean = false) {
    return new Promise(async (resolve, reject) => {
      //this.main.ShowLoading();
      this.projectService.getProjects(id_proy_camp).subscribe((x: any) => {
       // this.main.HideLoading();
        let selectedSucursalCorteId = x.data.project.selected_cutoff_id;
      
        if(selectedSucursalCorteId){
        
          this.getCutOffData(selectedSucursalCorteId).subscribe((y: any) =>{

              let data_get = {
                file_id : y.data[0].file_id,
                id_zonas: filtros.id_zonas,
                id_atributos: filtros.id_atributos,
                id_sucursales: filtros.id_sucursales,
                atributos_nombre: filtros.atributos_nombre,
                sucursales_filtro : sucursales_filtro
              }
              console.log( sucursales_filtro, "Hola")
              if(data_get){
              //  this.main.ShowLoading();
                this.storesService.getCuttOffDataByFileID(data_get).subscribe(
                  (result : any) => {    
                   // this.main.HideLoading();
                    if(persistent){
                        this.project_cutoff_file_data = result.data;
                    }
                
                    resolve(result.data);
        
                  },
                  (err : any) => {
                    resolve([]);
                    this.main.HideLoading();
                    console.log(err);
                  }
                );
            }

          });
        }
      },
      (err:any) => {
        resolve([]);
        console.log(err);
            this.main.HideLoading();
      });
    });
  }


   filtrarSucursales(filtros: any[]): any[] {
    const filtrosProcesados = filtros.map(filtro => {
      const valorNum = parseInt(filtro.valor);
      return {
        ...filtro,
        valor: isNaN(valorNum) ? filtro.valor : valorNum
      };
    });


    
      const isNullish = (v: any) => v === null || v === undefined || v === '';

      const toNumberStrict = (v: any): number | null => {
          const n = Number(v);
          return Number.isNaN(n) ? null : n;
      };

      const toTrimString = (v: any) => String(v).trim();

      const isNumericArray = (arr: any[]) =>
      arr.every(x => toNumberStrict(x) !== null);

      type Operador = 1 | 2 | 3 | 4;

      const operadores: Record<Operador, (val: any, filtroVal: any) => boolean> = {
          // IGUAL
          1: (val, filtroVal) => {
             const nFiltro = toNumberStrict(filtroVal);

                
             if (nFiltro === null) {
                 return toTrimString(val) === toTrimString(filtroVal);
             }

           
             const nVal = isNullish(val) ? 0 : toNumberStrict(val);
             if (nVal === null) return false;
            
              return nVal === nFiltro;
          },
          // MAYOR QUE
          2: (val, filtroVal) => {
              const nFiltro = toNumberStrict(filtroVal);
              if (nFiltro === null) return false;
          
              const nVal = isNullish(val) ? 0 : toNumberStrict(val);
              if (nVal === null) return false;
          
              return nVal > nFiltro;
          },
        
          // MENOR QUE
          3: (val, filtroVal) => {
              const nFiltro = toNumberStrict(filtroVal);
              if (nFiltro === null) return false;
          
              const nVal = isNullish(val) ? 0 : toNumberStrict(val);
              if (nVal === null) return false;
          
              return nVal < nFiltro;
          },
        
          // INCLUYE
          4: (val, filtroVal) => {
              let arr: any[];
          
              try {
                  arr = Array.isArray(filtroVal) ? filtroVal : JSON.parse(filtroVal);
              } catch {
                  return false;
              }
            
              if (!Array.isArray(arr)) return false;
            
              // Si el array es numerico regla numerica
              if (isNumericArray(arr)) {
                  const nVal = isNullish(val) ? 0 : toNumberStrict(val);
                  if (nVal === null) return false;
              
                  return arr.some(x => toNumberStrict(x) === nVal);
              }
            
              // Si es string comparar string
              const sVal = toTrimString(val);
              return arr.some(x => toTrimString(x) === sVal);
          }
      };

  
    return this.project_cutoff_file_data.filter((sucs:any) => {


      return filtrosProcesados.every(filtro => {
           const val = sucs[filtro.nombre];
           const operadorFn = operadores[filtro.operador as Operador];
           if (!operadorFn) return false;

           return operadorFn(val, filtro.valor);
       });
    });
  }

  getAtributos(){
    return this.main.getRequest(this.areaNameStores + "/attributes/list");
  }

}